import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/common/Elements/Elements';

import classes from './BodyDropdownSetting.module.scss';
import { hasAccess } from 'utils/permissions';

const BodyDropdownSetting = ({ items }) => {
  return (
    <ul className={classes.listWrap}>
      {items.map(
        item =>
          hasAccess(item.permission) && (
            <li key={item.label} className={classes.option}>
              <Button onClick={item.handleClick} className={classes.button}>
                {item.label}
              </Button>
            </li>
          )
      )}
    </ul>
  );
};

BodyDropdownSetting.propTypes = {
  items: PropTypes.array.isRequired
};

export default BodyDropdownSetting;
